/* Adapt PDP compare slider (2026-10-05). Left = regular glasses, right = Adapt Dew. Starts on the regular glasses, glides once to reveal the calm eyes, then belongs to the visitor (any touch/drag/key cancels the glide). Snap buttons glide too. Loaded with defer by sections/compare-adapt.liquid. */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ease(t){ return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  document.querySelectorAll('[data-cs]').forEach(function(root){
    var stage = root.querySelector('[data-cs-stage]');
    var range = root.querySelector('[data-cs-range]');
    if(!stage || !range) return;
    var tagL = root.querySelector('[data-cs-tag-l]');
    var tagR = root.querySelector('[data-cs-tag-r]');
    var segL = root.querySelector('[data-cs-seg-l]');
    var segR = root.querySelector('[data-cs-seg-r]');
    var raf = null, touched = false;

    function setPos(v){
      v = Math.max(0, Math.min(100, v));
      stage.style.setProperty('--pos', v.toFixed(2));
      range.value = String(v);
      if(tagL) tagL.classList.toggle('is-faded', v < 22);
      if(tagR) tagR.classList.toggle('is-faded', v > 78);
      if(segL) segL.classList.toggle('is-on', v > 66);
      if(segR) segR.classList.toggle('is-on', v < 34);
    }
    function cancel(){ if(raf){ cancelAnimationFrame(raf); raf = null; } }
    function glide(to, dur, done){
      cancel();
      var from = parseFloat(range.value) || 0, start = null;
      function step(ts){
        if(start === null) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        setPos(from + (to - from) * ease(p));
        if(p < 1){ raf = requestAnimationFrame(step); }
        else { raf = null; if(done) done(); }
      }
      raf = requestAnimationFrame(step);
    }

    range.addEventListener('input', function(){ touched = true; cancel(); setPos(parseFloat(range.value)); });
    ['pointerdown', 'touchstart', 'keydown'].forEach(function(ev){
      range.addEventListener(ev, function(){ touched = true; cancel(); }, { passive: true });
    });
    if(segL) segL.addEventListener('click', function(){ touched = true; glide(100, 550); });
    if(segR) segR.addEventListener('click', function(){ touched = true; glide(0, 550); });

    if(reduce || !('IntersectionObserver' in window)){
      setPos(50);
      return;
    }
    setPos(100);
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        io.disconnect();
        if(touched) return;
        glide(15, 1500, function(){ if(!touched) glide(50, 1000); });
      });
    }, { threshold: 0.55 });
    io.observe(stage);
  });
})();